module.exports = __webpack_public_path__ + "img/bottleCap.900e26fb.jpg";